import React, { useEffect, useRef, useState } from "react";
import { Stack } from "@mui/material";
import SectionControls from "components/ai-editor/section-controls/SectionControls";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { collection, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import { useCollection } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";
import DocumentSections from "components/ai-editor/DocumentSections";
import SectionNavigator from "components/ai-editor/SectionNavigator";

export default function AIEditor() {
  const theme = useTheme();
  const params = useParams();
  const documentId = params.documentId;

  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const [localSections, setLocalSections] = useState([]);
  const sectionRefs = useRef({});

  const q =
    uid && documentId
      ? query(
          collection(db, "documents", documentId, "sections"),
          where("uid", "==", uid)
        )
      : null;

  const [sectionsSnap, loading, error] = useCollection(q);

  useEffect(() => {
    if (sectionsSnap) {
      const sections = sectionsSnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .sort((x, y) => x.index - y.index);
      setLocalSections(sections);
    }
  }, [sectionsSnap]);

  if (error) {
    console.log(error);
  }

  // const handleDragEnd = (result) => {
  //   if (!result.destination) return;

  //   const newSections = Array.from(localSections);
  //   const [movedItem] = newSections.splice(result.source.index, 1);
  //   newSections.splice(result.destination.index, 0, movedItem);
  //   setLocalSections(newSections);

  //   const index = result.destination.index;
  //   let newIndex = 0;
  //   if (newSections.length > 0) {
  //     if (index === 0) {
  //       newIndex = newSections[index + 1].index - 1;
  //     } else if (index === newSections.length - 1) {
  //       newIndex = newSections[index - 1].index + 1;
  //     } else {
  //       newIndex =
  //         (newSections[index - 1].index + newSections[index + 1].index) / 2.0;
  //     }
  //   }

  //   updateDoc(
  //     doc(db, "documents", documentId, "sections", result.draggableId),
  //     {
  //       index: newIndex,
  //     }
  //   );
  // };

  // const renderHeaderNavigation = () => {
  //   console.log(localSections);
  //   const headerSections = localSections.filter(
  //     (section) => section.type === HEADER_TYPE.key
  //   );
  //   console.log(headerSections);
  //   return (
  //     <Stack
  //       sx={{
  //         width: 200,
  //         borderRight: `1px solid ${theme.palette.divider}`,
  //         p: 2,
  //         overflowY: "auto",
  //       }}
  //       spacing={1}
  //     >
  //       {headerSections.map((section) => (
  //         <Typography
  //           key={section.id}
  //           sx={{ cursor: "pointer" }}
  //           onClick={() => {
  //             sectionRefs.current[section.id]?.scrollIntoView({
  //               behavior: "smooth",
  //               block: "start",
  //             });
  //           }}
  //         >
  //           {section.text || "Untitled"}
  //         </Typography>
  //       ))}
  //     </Stack>
  //   );
  // };

  return (
    <Stack
      boxSizing="border-box"
      height="100%"
      overflow="hidden"
    >
      <SectionControls documentId={documentId} />
      <Stack
        direction="row"
        height="100%"
        overflow="hidden"
        boxSizing="border-box"
      >
        <Stack
          flexGrow={1}
          height="100%"
          boxSizing="border-box"
        >
          <DocumentSections
            documentId={documentId}
            loading={loading}
            sections={localSections}
            setSections={setLocalSections}
            sectionRefs={sectionRefs}
          />
        </Stack>
        <Stack width="250px" p={2}>
          <SectionNavigator
            documentId={documentId}
            loading={loading}
            sections={localSections}
            sectionRefs={sectionRefs}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
